import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslationModule } from '../../../i18n/translation.module';
import { StartupErrorService } from './startup-error.service';

@Component({
    selector: 'startup-error',
    templateUrl: './startup-error.component.html',
    imports: [CommonModule, TranslationModule],
    styles: [
        `
      :host-context(html) {
        overflow: hidden !important;
        overflow-x: hidden !important;
        overflow-y: hidden !important;
      }
    `,
    ]
})
export class StartupErrorComponent extends StartupErrorService {
  reload() {
    window.location.replace(window.location.origin);
  }
}
